/* eslint-disable typescript-sort-keys/string-enum */
export let ColumnFilterOperator;
(function (ColumnFilterOperator) {
  ColumnFilterOperator["BETWEEN"] = "BETWEEN";
  ColumnFilterOperator["CONTAINS"] = "CONTAINS";
  ColumnFilterOperator["DOES_NOT_CONTAIN"] = "DOES_NOT_CONTAIN";
  ColumnFilterOperator["EQUAL"] = "EQUAL";
  ColumnFilterOperator["FUTURE"] = "FUTURE";
  ColumnFilterOperator["GREATER_THAN"] = "GREATER_THAN";
  ColumnFilterOperator["GREATER_THAN_OR_EQUAL"] = "GREATER_THAN_OR_EQUAL";
  ColumnFilterOperator["IS_BLANK"] = "IS_BLANK";
  ColumnFilterOperator["IS_CHECKED"] = "IS_CHECKED";
  ColumnFilterOperator["IS_DATE"] = "IS_DATE";
  ColumnFilterOperator["IS_NOT_BLANK"] = "IS_NOT_BLANK";
  ColumnFilterOperator["IS_NOT_DATE"] = "IS_NOT_DATE";
  ColumnFilterOperator["IS_NOT_NUMBER"] = "IS_NOT_NUMBER";
  ColumnFilterOperator["IS_NOT_ONE_OF"] = "IS_NOT_ONE_OF";
  ColumnFilterOperator["IS_NUMBER"] = "IS_NUMBER";
  ColumnFilterOperator["IS_ONE_OF"] = "IS_ONE_OF";
  ColumnFilterOperator["IS_UNCHECKED"] = "IS_UNCHECKED";
  ColumnFilterOperator["LAST_N_DAYS"] = "LAST_N_DAYS";
  ColumnFilterOperator["LESS_THAN"] = "LESS_THAN";
  ColumnFilterOperator["LESS_THAN_OR_EQUAL"] = "LESS_THAN_OR_EQUAL";
  ColumnFilterOperator["NEXT_N_DAYS"] = "NEXT_N_DAYS";
  ColumnFilterOperator["NOT_BETWEEN"] = "NOT_BETWEEN";
  ColumnFilterOperator["NOT_EQUAL"] = "NOT_EQUAL";
  ColumnFilterOperator["NOT_FUTURE"] = "NOT_FUTURE";
  ColumnFilterOperator["NOT_LAST_N_DAYS"] = "NOT_LAST_N_DAYS";
  ColumnFilterOperator["NOT_NEXT_N_DAYS"] = "NOT_NEXT_N_DAYS";
  ColumnFilterOperator["NOT_ON_CRITICAL_PATH"] = "NOT_ON_CRITICAL_PATH";
  ColumnFilterOperator["NOT_PAST"] = "NOT_PAST";
  ColumnFilterOperator["NOT_TODAY"] = "NOT_TODAY";
  ColumnFilterOperator["ON_CRITICAL_PATH"] = "ON_CRITICAL_PATH";
  ColumnFilterOperator["PAST"] = "PAST";
  ColumnFilterOperator["TODAY"] = "TODAY";
  ColumnFilterOperator["HAS_ALL_OF"] = "HAS_ALL_OF";
  ColumnFilterOperator["HAS_ANY_OF"] = "HAS_ANY_OF";
  ColumnFilterOperator["HAS_NONE_OF"] = "HAS_NONE_OF";
  ColumnFilterOperator["MULTI_IS_EQUAL"] = "MULTI_IS_EQUAL";
  ColumnFilterOperator["MULTI_IS_NOT_EQUAL"] = "MULTI_IS_NOT_EQUAL";
  ColumnFilterOperator["NOT_ALL_OF"] = "NOT_ALL_OF";
})(ColumnFilterOperator || (ColumnFilterOperator = {}));
export let RowFilterOperator;
/* eslint-enable typescript-sort-keys/string-enum */
(function (RowFilterOperator) {
  RowFilterOperator["HAS_ATTACHMENTS"] = "HAS_ATTACHMENTS";
  RowFilterOperator["HAS_COMMENTS"] = "HAS_COMMENTS";
  RowFilterOperator["IS_LOCKED"] = "IS_LOCKED";
  RowFilterOperator["NOT_LOCKED"] = "NOT_LOCKED";
  RowFilterOperator["NO_ATTACHMENTS"] = "NO_ATTACHMENTS";
  RowFilterOperator["NO_COMMENTS"] = "NO_COMMENTS";
})(RowFilterOperator || (RowFilterOperator = {}));
export let FilterTypeEnum;
(function (FilterTypeEnum) {
  FilterTypeEnum["ADHOC"] = "ADHOC";
  FilterTypeEnum["SHARED"] = "SHARED";
  FilterTypeEnum["USER"] = "USER";
})(FilterTypeEnum || (FilterTypeEnum = {}));
export let FilterJoinCriteria;
(function (FilterJoinCriteria) {
  FilterJoinCriteria["AND"] = "AND";
  FilterJoinCriteria["OR"] = "OR";
})(FilterJoinCriteria || (FilterJoinCriteria = {}));
export let FilterTargetType;
(function (FilterTargetType) {
  FilterTargetType["COLUMN"] = "COLUMN";
  FilterTargetType["ROW"] = "ROW";
})(FilterTargetType || (FilterTargetType = {}));
/**
 * Mapping of data type for the filter value,
 * mapped to FilterValues.yaml in gridservice-api
 *
 */
export let FilterValueDataType;
(function (FilterValueDataType) {
  FilterValueDataType["Boolean"] = "boolean";
  FilterValueDataType["Contact"] = "contact";
  FilterValueDataType["DateTime"] = "dateTime";
  FilterValueDataType["NullValue"] = "nullValue";
  FilterValueDataType["Number"] = "number";
  FilterValueDataType["SystemContact"] = "systemContact";
  FilterValueDataType["Text"] = "text";
})(FilterValueDataType || (FilterValueDataType = {}));
//# sourceMappingURL=SavedFilters.js.map